import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=64569cdc&scoped=true"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64569cdc",
  null
  
)

export default component.exports